import { z } from "zod";

import { IndustrialProcessSchema, OptimizationTypeSchema } from "../types";
import type { DomainErrorKey } from "../domainErrors/domainErrors";

export const ImpactedOptimizationSchema = z.object({
  id: z.string(),
  type: OptimizationTypeSchema,
  lineCount: z.number().int(),
  materialName: z.string().nullable(),
  height: z.number().nullable(),
  industrialProcess: IndustrialProcessSchema.nullable(),
});

export type ImpactedOptimization = z.infer<typeof ImpactedOptimizationSchema>;

export const OPTIMIZATION_INVALIDATION_CONFIRMATION_HEADER = "x-confirm-optimization-invalidation";

export const OPTIMIZATION_CONFIRMATION_REQUIRED = {
  code: "OPTIMIZATION.CONFIRMATION_REQUIRED",
  http: 409,
} as const satisfies { code: DomainErrorKey; http: number };

export type OptimizationInvalidationOperation =
  | { type: "UPDATE" }
  | { type: "DELETE"; resource: "QUOTE_REQUEST_LINE"; count: number }
  | { type: "DELETE"; resource: "PROCESS_STEP" };
